import { toast } from 'react-toastify'

/**
 * Toasts the bell must not log, for events something else already records.
 *
 * Its own module, importing nothing but react-toastify, so a caller can announce something without
 * pulling in the notification API layer (and through it `services` and `config`) at module scope.
 * See `toastCapture`, which reads the set, and `components/BackgroundRuns/store`, which is reached
 * from the base layout during boot and must stay out of that part of the module graph.
 */
export const uncapturedToastIds = new Set<string>()

/**
 * Show a toast the bell must not log.
 *
 * For events the backend already raises its own notification for, such as a background report run
 * finishing, where the notification carries a working download link. Without this the same event
 * would list twice in the panel: once from the backend, once from the toast that announced it.
 */
export const toastUncaptured = (content: any, options: any = {}) => {
  const id = `uncaptured:${Date.now()}:${Math.random().toString(36).slice(2)}`
  uncapturedToastIds.add(id)
  toast(content, { ...options, toastId: id })
  // Capture happens synchronously on `added`; the id is held a little longer only so a toast that
  // is updated in place is still recognised, then released so the set cannot grow unbounded.
  setTimeout(() => uncapturedToastIds.delete(id), 60 * 1000)
}
